import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { CoreHelperUtil } from '@web3modal/scaffold';
import { ConstantsUtil, PresetsUtil } from '@web3modal/scaffold-utils';
const RPC_URL = CoreHelperUtil.getBlockchainApiUrl();
export function walletConnectProvider(_ref) {
  let {
    projectId
  } = _ref;
  return function provider(chain) {
    if (!PresetsUtil.WalletConnectRpcChainIds.includes(chain.id)) {
      return null;
    }
    const baseHttpUrl = "".concat(RPC_URL, "/v1/?chainId=").concat(ConstantsUtil.EIP155, ":").concat(chain.id, "&projectId=").concat(projectId);
    return {
      chain: _objectSpread(_objectSpread({}, chain), {}, {
        rpcUrls: _objectSpread(_objectSpread({}, chain.rpcUrls), {}, {
          default: {
            http: [baseHttpUrl]
          }
        })
      }),
      rpcUrls: {
        http: [baseHttpUrl]
      }
    };
  };
}
//# sourceMappingURL=provider.js.map